import React, {Component} from 'react'
import '../styles/Footer.css'
import {Link} from "react-router-dom";
import AdminService from "../admin/adminComponents/AdminService";
import ue from '../img/logotypywszystkie.png'
import plansza from '../img/plansza_informacyjna_PFR.jpg'
import po from '../img/programoperacyjny.jpeg'
import AppConfig from "../AppConfig";

export default class Footer extends Component {

    constructor(props) {
        super(props);

        this.state = {
            dataKategorie: [],
            dataStrony: [],
            loading: true
        }
    }

    componentWillMount() {
        AdminService.getKategorie()
            .then(function (response) {
                let res = response.data.content;
                AdminService.getStronyByTyp('PAGE', true)
                    .then(function (response) {
                        let res2 = response.data;
                        res2 = res2.filter(el => el.kategoria !== null);
                        this.setState({dataKategorie: res, dataStrony: res2, loading: false})
                    }.bind(this)).catch(err => {
                    console.log(err)
                })
            }.bind(this)).catch(err => {
            console.log(err)
        })
    }

    render() {
        return (
            <div className="container footer">
                {this.state.loading ? <div>
                        <div className="loaderDim" style={{textAlign: 'center', paddingTop: 50, paddingBottom: 50}}><i
                            className="fa fa-spinner fa-pulse fa-2x fa-fw"
                            style={{
                                color: '#58b13d'
                            }}> </i></div>
                    </div> :
                    <div className="row">
                        <div className="col-sm-3">
                            <h5>Obserwuj nas</h5>
                            <hr/>
                            <ul>
                                <li style={{display: 'inline-flex'}}>
                                    <a href='https://www.facebook.com/marcel-buspl-133719136689152/' target="_blank">
                                        <div className="facebook"><i className="fa fa-facebook"> </i></div>
                                    </a>
                                    <a href='https://www.instagram.com/marcelbusrzeszow/' target="_blank">
                                        <div className="instagram"><i className="fa fa-instagram"> </i></div>
                                    </a>
                                    <a href='https://twitter.com/marcelbus' target="_blank">
                                        <div className="twitter"><i className="fa fa-twitter"> </i></div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="col-sm-3">
                            {this.state.dataKategorie.map((item, i) => {
                                if (item.nazwa !== 'Elementy witryny' && i !== 1) {
                                    return <div>
                                        <h5>{item.nazwa}</h5>
                                        <hr/>
                                        <ul>
                                            {this.state.dataStrony.map((strona, index) => {
                                                if (strona.kategoria.id === item.id) {
                                                    if (strona.tresc.substr(0, 1) === '/') {
                                                        return <li><Link to={strona.tresc}>{strona.tytul}</Link></li>
                                                    } else {
                                                        return <Link to={'/strona/' + item.id + '/' + strona.id}>
                                                            <li>{strona.tytul}</li>
                                                        </Link>
                                                    }
                                                }
                                            })}
                                        </ul>
                                    </div>
                                }
                            })}
                        </div>
                        <div className="col-sm-3">
                            <h5>Informacja</h5>
                            <hr/>
                            <ul>
                                <li style={{color: '#565756'}}>Pon.-Pt.</li>
                                <li>8:00 - 20:00</li>
                                <li style={{color: '#565756'}}>Sob.-Niedz.</li>
                                <li>9:00 - 18:00</li>
                                <li style={{marginTop: '5px'}}>882 005 006</li>
                                <li>600 377 797</li>
                                <li>795 005 006</li>
                                <li>&nbsp;</li>
                                <li>Bilety miesięczne:</li>
                                <li>8:30 - 15:30</li>
                                <li>535 377 797</li>
                                <li>&nbsp;</li>
                                <li>Wynajem autobusów:</li>
                                <li>530 308 030</li>
                            </ul>
                            <h5>Rezerwacja</h5>
                            <hr/>
                            <ul>
                                <li>Rzeszów - Lublin - Rymanów Zdrój - Lublin:</li>
                                <li>8:00 - 20:00</li>
                                <li>600 200 585</li>
                            </ul>
                        </div>
                        < div className="col-sm-3">
                            <h5>Odwiedź nasze biuro</h5>
                            <hr/>
                            <ul>
                                <li>Dworzec Lokalny</li>
                                <li>Ambrożego Towarnickiego 7</li>
                                <li>35-010 Rzeszów</li>
                                <li>&nbsp;</li>
                                <li>Godziny otwarcia:</li>
                                <li>pon-pt: 8:30 - 15:30</li>
                            </ul>
                        </div>
                    </div>}
                <div className="row" style={{marginTop: 25}}>
                    <hr style={{
                        marginLeft: 0, marginRight: 0,
                        borderTop: '1px solid rgba(0,0,0,.1)',
                        width: '100%'
                    }}/>
                    <div className="col-12 text-center">
                        <img src={plansza} style={{maxWidth: '70%'}}/>
                    </div>

                    <div className="col-12 text-center">
                        <img src={po} style={{maxWidth: '60%'}}/>
                        <p style={{fontSize: '0.75rem', color: '#9c9c9c', marginTop: 10, marginBottom: '50px'}}>Program Operacyjny Polska Wschodnia oś priorytetowa 1 Przedsiębiorcza Polska Wschodnia działanie 1.5 Dotacje na kapitał obrotowy</p>
                    </div>

                    <div className="col-12 text-center">
                        <img src={ue} style={{maxWidth: '60%'}}/>
                        <p style={{fontSize: '0.75rem', color: '#9c9c9c', marginTop: 10}}>Projekt współfinansowany z
                            Europejskiego Funduszu Rozwoju Regionalnego w ramach poddziałania 1.4.1
                            Regionalnego Programu Operacyjnego Województwa Podkarpackiego na lata 2014 – 2020.</p>
                    </div>

                    <hr style={{
                        marginLeft: 0, marginRight: 0,
                        borderTop: '1px solid rgba(0,0,0,.1)',
                        width: '100%'
                    }}/>
                    <div className={'col-12 text-center'}>
                        <p style={{fontSize: '0.75rem', color: '#9c9c9c'}}>{AppConfig.DATE_OF_MODIFICATION()} © 2026
                            Marcel Bus ‐ Wszelkie prawa zastrzeżone - Realizacja: <a href={'http://topsa.com.pl/'} target="_blank">TOP S.A. </a>- oprogramowanie:<a href={'https://ebus.topsa.com.pl/'} target="_blank"> Top eBUS</a> </p>
                    </div>
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/shared/Footer.js